import httpClient from "../http/http-client";
import { IPostProject, IProject } from './project.model';

export default class ProjectService {
  http;
  projects?: IProject[];
  static instance = new ProjectService();

  static getInstance() {
    if (ProjectService.instance === null) ProjectService.instance = new ProjectService();
    return this.instance;
  }

  constructor() {
    this.http = httpClient
  }

  async getAll(queryString?: string, forceUpdate: boolean = false): Promise<IProject[]> {
    if (this.projects && !forceUpdate && !queryString) {
      return Promise.resolve(this.projects);
    }
    return this.http.get(`project${queryString ? queryString : ''}`)
      .then(response => {
        const rows = response.data.rows;
        if (!queryString) this.projects = rows;
        return rows;
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getAllActive(): Promise<IProject[]> {
    return this.http.get(`project?active=true`)
      .then(response => {
        return response.data.rows
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }


  // reportPeriodId adds each project's period totals (totalEmissions, spendTotals) to the rows.
  async getAllWithPagination(active: boolean, searchQuery: string, page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc', reportPeriodId?: string | null): Promise<{ count: number, rows: IProject[] }> {
    return this.http.get(`project?active=${active}&nameIncludes=${searchQuery}&page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}${reportPeriodId ? `&reportPeriodId=${reportPeriodId}&includeTotals=true` : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }

  async getOne(id: string, queryString?: string): Promise<IProject> {
    return this.http.get(`project/${id}${queryString ? queryString : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async create(project: IPostProject): Promise<IProject> {
    return this.http.post(`project`, project)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async update(projectId: string, project: IPostProject): Promise<IProject> {
    return this.http.patch(`project/${projectId}`, project)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async remove(projectId: string): Promise<IProject> {
    return this.http.delete(`project/${projectId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async deactivate(projectId: string): Promise<IProject> {
    return this.http.patch(`project/${projectId}/deactivate`, { projectId })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  clearData() {
    this.projects = undefined;
  }
}